@if (form) {
  <mat-card>
    <app-card-header
      [title]="title"
      icono="sensors"
      [botonCerrar]="true"
      (cerrar)="dialogRef.close()"
    ></app-card-header>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <mat-card-content class="card-content-crear">
        <!-- Datos de la zona -->
        <app-content-card title="Zona" icon="label">
          <section class="inputs-group">
            <mat-form-field class="full-width">
              <mat-label>Nombre de la zona</mat-label>
              <input matInput formControlName="nombre" />
            </mat-form-field>
          </section>

          <!-- Partición y Zona en una fila -->
          <section class="inputs-group">
            <mat-form-field class="flex-1">
              <mat-label>Partición</mat-label>
              <input matInput type="number" formControlName="particion" />
            </mat-form-field>
            <mat-form-field class="flex-1">
              <mat-label>Número de zona</mat-label>
              <input matInput type="number" formControlName="zona" />
            </mat-form-field>
          </section>

          <!-- Modo -->
          <section class="inputs-group">
            <ng-select
              [items]="modoSensor"
              formControlName="modo"
              placeholder="Modo del sensor"
              multiple="false"
              searchable="true"
              appendTo="body"
              notFoundText="Sin resultados"
              class="full-width"
            ></ng-select>
          </section>
        </app-content-card>

        <!-- Sensores -->
        <app-content-card title="Sensores" icon="sensors">
          <div formArrayName="sensores" class="sensores-list">
            @for (
              sensor of sensoresArray.controls;
              track sensor;
              let i = $index
            ) {
              <div class="sensor-card" [formGroupName]="i">
                <div class="sensor-header">
                  <span class="sensor-title">
                    <mat-icon>sensors</mat-icon>
                    Sensor {{ i + 1 }}
                  </span>
                  @if (sensoresArray.length > 1) {
                    <button
                      irxBotonIcono
                      tooltip="Cerrar"
                      tono="peligro"
                      type="button"
                      (click)="removeSensor(i)"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </div>

                <div class="sensor-fields">
                  <!-- Tipo -->
                  <ng-select
                    class="ng-select-wrapper"
                    formControlName="tipo"
                    placeholder="Tipo"
                    [items]="tipoSensoresItems"
                    bindLabel="etiqueta"
                    bindValue="valor"
                    appendTo="body"
                    notFoundText="Sin resultados"
                  ></ng-select>

                  <!-- Marca -->
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Marca</mat-label>
                    <input
                      matInput
                      formControlName="marca"
                      [matAutocomplete]="autoMarca"
                    />
                    <mat-autocomplete #autoMarca="matAutocomplete">
                      @for (opcion of marcasObs$[i] | async; track opcion) {
                        <mat-option [value]="opcion">{{ opcion }}</mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>

                  <!-- Modelo -->
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Modelo</mat-label>
                    <input
                      matInput
                      formControlName="modelo"
                      [matAutocomplete]="autoModelo"
                    />
                    <mat-autocomplete #autoModelo="matAutocomplete">
                      @for (opcion of modelosObs$[i] | async; track opcion) {
                        <mat-option [value]="opcion">{{ opcion }}</mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </div>
            }
          </div>

          <button
            irxBoton="secundario"
            bloque
            type="button"
            (click)="addSensor()"
          >
            <mat-icon>add</mat-icon>
            Agregar sensor
          </button>
        </app-content-card>
      </mat-card-content>

      <mat-card-actions class="actions-create">
        <button irxBoton="secundario" type="button" (click)="dialogRef.close()">
          Cancelar
        </button>
        <button
          irxBoton="principal"
          type="submit"
          [disabled]="!this.form.valid"
        >
          <mat-icon>save</mat-icon>
          Guardar
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
}
